import './slider.scss';

$(document).ready(function(){
  let $slides = $('.slider-main .swiper-slide');

  if ( $slides.length > 1 ) {
    new window.Swiper('.slider-main', {
      loop: true,
      speed: 850,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
});
